import { isNil, omitBy } from 'lodash';
import config from '../config';
import { serialize } from 'object-to-formdata';
import { UiError } from './errors';
export class Api {
    constructor(resourcePath) {
        this.rootUrl = config('API_URL');
        this.resourcePath = resourcePath || '';
    }
    getFullUrl(url) {
        return `${this.rootUrl}${this.resourcePath}${url}`;
    }
    async fetch(url, options = {}) {
        const requestOptions = Object.assign({ credentials: 'include' }, options);
        const response = await window.fetch(this.getFullUrl(url), requestOptions);
        if (!response.ok) {
            const resError = await response.json();
            throw new UiError(resError);
        }
        if (response.status === 204) {
            return;
        }
        const json = await response.json();
        return json;
    }
    async get(url, params) {
        if (params) {
            const paramsString = new URLSearchParams(omitBy(params, isNil));
            url = `${url}?${paramsString}`;
        }
        return this.fetch(url);
    }
    async post(url, body, files) {
        const reqBody = files ? serialize(Object.assign(Object.assign({}, body), { files })) : JSON.stringify(body);
        const reqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: reqBody,
        };
        if (files) {
            delete reqOptions.headers;
        }
        return this.fetch(url, reqOptions);
    }
    async put(url, body, files) {
        const reqBody = files ? serialize(Object.assign(Object.assign({}, body), { files })) : JSON.stringify(body);
        const reqOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: reqBody,
        };
        if (files) {
            delete reqOptions.headers;
        }
        return this.fetch(url, reqOptions);
    }
    async delete(url, params) {
        if (params) {
            url = `${url}?${new URLSearchParams(params)}`;
        }
        const reqOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        };
        return this.fetch(url, reqOptions);
    }
}
export function UiErrorByStatus(messageMap) {
    const defaultMessage = 'An error occurred!';
    return function (_, __, descriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = async function (...args) {
            try {
                const res = await originalMethod.apply(this, args);
                return res;
            }
            catch (responseError) {
                const message = (messageMap === null || messageMap === void 0 ? void 0 : messageMap[String(responseError.status)]) || (messageMap === null || messageMap === void 0 ? void 0 : messageMap.default) ||
                    defaultMessage;
                throw responseError;
            }
        };
        return descriptor;
    };
}
